import React, { useEffect } from 'react';

import appUpdateGuideImage from '@/assets/images/app-update-guide.png';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.zigtruck.android';

interface AppUpdateFullscreenPopupProps {
  isOpen: boolean;
}

const AppUpdateFullscreenPopup = ({ isOpen }: AppUpdateFullscreenPopupProps) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-white">
      <div className="relative flex h-full w-full max-w-[720px] items-center justify-center px-4">
        <div className="relative inline-block max-h-full max-w-full">
          <img
            src={appUpdateGuideImage}
            alt="사용하기 편해진 직트럭 앱"
            className="block h-auto max-h-[100dvh] w-auto max-w-full object-contain"
          />
          <a
            href={PLAY_STORE_URL}
            className="absolute bottom-[4.5%] left-1/2 h-[10.5%] w-[88%] max-w-[320px] -translate-x-1/2 cursor-pointer"
            aria-label="업데이트"
          />
        </div>
      </div>
    </div>
  );
};

export default AppUpdateFullscreenPopup;
